<div class="privacy-policy-wrapper">
  <div class="privacy-policy-container">
    <h1 class="privacy-policy-title">{{ "PRIVACY_POLICY.TITLE" | translate }}</h1>

    <section>
      <app-accordion>
        <app-accordion-item [title]="'1. ' + ('PRIVACY_POLICY.ARTICLE_1.TITLE' | translate)">
          <div class="privacy-section">
            <p class="privacy-policy-heading"><span>{{ "PRIVACY_POLICY.ARTICLE_1.TITLE" | translate }}</span></p>
            <p>{{ "PRIVACY_POLICY.ARTICLE_1.DESC_1" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_1.DESC_2" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_1.DESC_3" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_1.DESC_4" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_1.DESC_5" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_1.DESC_6" | translate }}</p>
          </div>
        </app-accordion-item>

        <app-accordion-item [title]="'2. ' + ('PRIVACY_POLICY.ARTICLE_2.TITLE' | translate)">
          <div class="privacy-section">
            <p class="privacy-policy-heading"><span>{{ "PRIVACY_POLICY.ARTICLE_2.TITLE" | translate }}</span></p>
            <p>{{ "PRIVACY_POLICY.ARTICLE_2.DESC_1" | translate }}</p>
            <p>{{ "PRIVACY_POLICY.ARTICLE_2.DESC_2" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_2.DESC_3" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_2.DESC_4" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_2.DESC_5" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_2.DESC_6" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_2.DESC_7" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_2.DESC_8" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_2.DESC_9" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_2.DESC_10" | translate }}</p>
          </div>
        </app-accordion-item>

        <app-accordion-item [title]="'3. ' + ('PRIVACY_POLICY.ARTICLE_3.TITLE' | translate)">
          <div class="privacy-section">
            <p class="privacy-policy-heading"><span>{{ "PRIVACY_POLICY.ARTICLE_3.TITLE" | translate }}</span></p>
            <p>{{ "PRIVACY_POLICY.ARTICLE_3.DESC_1" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_3.DESC_2" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_3.DESC_3" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_3.DESC_4" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_3.DESC_5" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_3.DESC_6" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_3.DESC_7" | translate }}</p>
          </div>
        </app-accordion-item>

        <app-accordion-item [title]="'4. ' + ('PRIVACY_POLICY.ARTICLE_4.TITLE' | translate)">
          <div class="privacy-section">
            <p class="privacy-policy-heading"><span>{{ "PRIVACY_POLICY.ARTICLE_4.TITLE" | translate }}</span></p>
            <p>{{ "PRIVACY_POLICY.ARTICLE_4.DESC_1" | translate }}</p>
          </div>
        </app-accordion-item>

        <app-accordion-item [title]="'5. ' + ('PRIVACY_POLICY.ARTICLE_5.TITLE' | translate)">
          <div class="privacy-section">
            <p class="privacy-policy-heading"><span>{{ "PRIVACY_POLICY.ARTICLE_5.TITLE" | translate }}</span></p>
            <p>{{ "PRIVACY_POLICY.ARTICLE_5.DESC_1" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_5.DESC_2" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_5.DESC_3" | translate }}</p>
            <ul>
              <li>{{ "PRIVACY_POLICY.ARTICLE_5.DESC_4" | translate }}</li>
              <li>{{ "PRIVACY_POLICY.ARTICLE_5.DESC_5" | translate }}</li>
              <li>{{ "PRIVACY_POLICY.ARTICLE_5.DESC_6" | translate }}</li>
              <li>{{ "PRIVACY_POLICY.ARTICLE_5.DESC_7" | translate }}</li>
              <li>{{ "PRIVACY_POLICY.ARTICLE_5.DESC_8" | translate }}</li>
              <li>{{ "PRIVACY_POLICY.ARTICLE_5.DESC_9" | translate }}</li>
            </ul>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_5.DESC_10" | translate }}</p>
          </div>
        </app-accordion-item>

        <app-accordion-item [title]="'6. ' + ('PRIVACY_POLICY.ARTICLE_6.TITLE' | translate)">
          <div class="privacy-section">
            <p class="privacy-policy-heading"><span>{{ "PRIVACY_POLICY.ARTICLE_6.TITLE" | translate }}</span></p>
            <p>{{ "PRIVACY_POLICY.ARTICLE_6.DESC_1" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_6.DESC_2" | translate }}</p>
            <ul>
              <li>{{ "PRIVACY_POLICY.ARTICLE_6.DESC_3" | translate }}</li>
              <li>{{ "PRIVACY_POLICY.ARTICLE_6.DESC_4" | translate }}</li>
              <li>{{ "PRIVACY_POLICY.ARTICLE_6.DESC_5" | translate }}</li>
              <li>{{ "PRIVACY_POLICY.ARTICLE_6.DESC_6" | translate }}</li>
              <li>{{ "PRIVACY_POLICY.ARTICLE_6.DESC_7" | translate }}</li>
              <li>{{ "PRIVACY_POLICY.ARTICLE_6.DESC_8" | translate }}</li>
              <li>{{ "PRIVACY_POLICY.ARTICLE_6.DESC_9" | translate }}</li>
            </ul>
          </div>
        </app-accordion-item>

        <app-accordion-item [title]="'7. ' + ('PRIVACY_POLICY.ARTICLE_7.TITLE' | translate)">
          <div class="privacy-section">
            <p class="privacy-policy-heading"><span>{{ "PRIVACY_POLICY.ARTICLE_7.TITLE" | translate }}</span></p>
            <p>{{ "PRIVACY_POLICY.ARTICLE_7.DESC_1" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_7.DESC_2" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_7.DESC_3" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_7.DESC_4" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_7.DESC_5" | translate }}</p>
          </div>
        </app-accordion-item>

        <app-accordion-item [title]="'8. ' + ('PRIVACY_POLICY.ARTICLE_8.TITLE' | translate)">
          <div class="privacy-section">
            <p class="privacy-policy-heading"><span>{{ "PRIVACY_POLICY.ARTICLE_8.TITLE" | translate }}</span></p>
            <p>{{ "PRIVACY_POLICY.ARTICLE_8.DESC_1" | translate }}</p>
          </div>
        </app-accordion-item>

        <app-accordion-item [title]="'9. ' + ('PRIVACY_POLICY.ARTICLE_9.TITLE' | translate)">
          <div class="privacy-section">
            <p class="privacy-policy-heading"><span>{{ "PRIVACY_POLICY.ARTICLE_9.TITLE" | translate }}</span></p>
            <p>{{ "PRIVACY_POLICY.ARTICLE_9.DESC_1" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_9.DESC_2" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_9.DESC_3" | translate }}</p>
          </div>
        </app-accordion-item>

        <app-accordion-item [title]="'10. ' + ('PRIVACY_POLICY.ARTICLE_10.TITLE' | translate)">
          <div class="privacy-section">
            <p class="privacy-policy-heading"><span>{{ "PRIVACY_POLICY.ARTICLE_10.TITLE" | translate }}</span></p>
            <p>{{ "PRIVACY_POLICY.ARTICLE_10.DESC_1" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_10.DESC_2" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_10.DESC_3" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_10.DESC_4" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_10.DESC_5" | translate }}</p>
          </div>

          <div class="privacy-section">
            <p class="privacy-policy-heading"><span>10.1. {{ "PRIVACY_POLICY.ARTICLE_10_1.TITLE" | translate }}</span></p>
            <p>{{ "PRIVACY_POLICY.ARTICLE_10_1.DESC_1" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_10_1.DESC_2" | translate }}</p>
          </div>

          <div class="privacy-section">
            <p class="privacy-policy-heading"><span>10.2. {{ "PRIVACY_POLICY.ARTICLE_10_2.TITLE" | translate }}</span></p>
            <p>{{ "PRIVACY_POLICY.ARTICLE_10_2.DESC_1" | translate }}</p>
          </div>
        </app-accordion-item>

        <app-accordion-item [title]="'11. ' + ('PRIVACY_POLICY.ARTICLE_11.TITLE' | translate)">
          <div class="privacy-section">
            <p class="privacy-policy-heading"><span>{{ "PRIVACY_POLICY.ARTICLE_11.TITLE" | translate }}</span></p>
            <p>{{ "PRIVACY_POLICY.ARTICLE_11.DESC_1" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_11.DESC_2" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_11.DESC_3" | translate }}</p>
          </div>

          <div class="privacy-section">
            <p class="privacy-policy-heading"><span>11.1. {{ "PRIVACY_POLICY.ARTICLE_11_1.TITLE" | translate }}</span></p>
            <p [innerHTML]="'PRIVACY_POLICY.ARTICLE_11_1.DESC_1' | translate"></p>
          </div>

          <div class="privacy-section">
            <p class="privacy-policy-heading"><span>11.2. {{ "PRIVACY_POLICY.ARTICLE_11_2.TITLE" | translate }}</span></p>
            <p [innerHTML]="'PRIVACY_POLICY.ARTICLE_11_2.DESC_1' | translate"></p>
          </div>

          <div class="privacy-section">
            <p class="privacy-policy-heading"><span>11.3. {{ "PRIVACY_POLICY.ARTICLE_11_3.TITLE" | translate }}</span></p>
            <p [innerHTML]="'PRIVACY_POLICY.ARTICLE_11_3.DESC_1' | translate"></p>
          </div>

          <div class="privacy-section">
            <p class="privacy-policy-heading"><span>11.4. {{ "PRIVACY_POLICY.ARTICLE_11_4.TITLE" | translate }}</span></p>
            <p [innerHTML]="'PRIVACY_POLICY.ARTICLE_11_4.DESC_1' | translate"></p>
          </div>

          <div class="privacy-section">
            <p class="privacy-policy-heading"><span>11.5. {{ "PRIVACY_POLICY.ARTICLE_11_5.TITLE" | translate }}</span></p>
            <p [innerHTML]="'PRIVACY_POLICY.ARTICLE_11_5.DESC_1' | translate"></p>
          </div>

          <div class="privacy-section">
            <p class="privacy-policy-heading"><span>11.6. {{ "PRIVACY_POLICY.ARTICLE_11_6.TITLE" | translate }}</span></p>
            <p [innerHTML]="'PRIVACY_POLICY.ARTICLE_11_6.DESC_1' | translate"></p>
          </div>

          <div class="privacy-section">
            <p class="privacy-policy-heading"><span>11.7. {{ "PRIVACY_POLICY.ARTICLE_11_7.TITLE" | translate }}</span></p>
            <p>{{ "PRIVACY_POLICY.ARTICLE_11_7.DESC_1" | translate }}</p>
          </div>
        </app-accordion-item>

        <app-accordion-item [title]="'12. ' + ('PRIVACY_POLICY.ARTICLE_12.TITLE' | translate)">
          <div class="privacy-section">
            <p class="privacy-policy-heading"><span>{{ "PRIVACY_POLICY.ARTICLE_12.TITLE" | translate }}</span></p>
            <p>{{ "PRIVACY_POLICY.ARTICLE_12.DESC_1" | translate }}</p>
          </div>
        </app-accordion-item>

        <app-accordion-item [title]="'PRIVACY_POLICY.ARTICLE_CARDS.TITLE' | translate">
          <div class="privacy-section">
            <p class="privacy-policy-heading"><span>{{ "PRIVACY_POLICY.ARTICLE_CARDS.TITLE" | translate }}</span></p>
            <p>{{ "PRIVACY_POLICY.ARTICLE_CARDS.DESC_1" | translate }}</p>
          </div>
        </app-accordion-item>

        <app-accordion-item [title]="'PRIVACY_POLICY.ARTICLE_INFO.TITLE' | translate">
          <div class="privacy-section">
            <p class="privacy-policy-heading"><span>{{ "PRIVACY_POLICY.ARTICLE_INFO.TITLE" | translate }}</span></p>
            <p>{{ "PRIVACY_POLICY.ARTICLE_INFO.DESC_1" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_INFO.DESC_2" | translate }}</p>
            <p class="mt-2">{{ "PRIVACY_POLICY.ARTICLE_INFO.DESC_3" | translate }}</p>
          </div>
        </app-accordion-item>
      </app-accordion>
    </section>
  </div>
</div>